import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { FormGroup, FormControlLabel, Switch } from "@mui/material";
import SearchOutlined from "@mui/icons-material/SearchOutlined";
import moment from "moment";
import ChatBox from "./ChatBox";
import "./Broadcast.css";
import AgentList from "../../Components/AgentList";
import { sendInternalBroadcastMessage } from "../../Store/Actions/ChatAction";

const Broadcast = ({ activeAgents, isAgentListLoading }) => {
  const [searchValue, setSearchValue] = useState("");
  const [selectedAgentIDs, setSelectedAgentIDs] = useState([]);
  const [searchedAgents, setSearchedAgents] = useState([]);
  const [isAllAgentsSelected, setIsAllAgentsSelected] = useState(false);
  const [messageToBroadcast, setMessageToBroadcast] = useState("");
  const { myInfo } = useSelector((state) => state.auth);

  useEffect(() => {
    // Update isAllAgentsSelected when selectedAgentIDs is updated
    searchedAgents.length &&
      setIsAllAgentsSelected(searchedAgents.length === selectedAgentIDs.length);
  }, [selectedAgentIDs]);

  useEffect(() => {
    // All agents except the current user
    const filteredActiveAgents = activeAgents.filter(
      (agent) => agent.AgentID !== myInfo.user.AgentID
    );

    setSearchedAgents(
      filteredActiveAgents.filter((agent) => {
        const fullName = `${agent.FirstName} ${agent.LastName}`;
        return fullName.toLowerCase().includes(searchValue);
      })
    );
  }, [searchValue]);

  const handleSendBroadcast = () => {
    const payload = {
      senderID: myInfo.user.AgentID,
      senderName: myInfo.user.AgentName,
      message: messageToBroadcast,
      time: moment().toISOString(),

      recipientIDs: selectedAgentIDs.map((ID) => {
        return { recipientID: ID };
      }),
    };

    sendInternalBroadcastMessage(payload)
      .then((response) => {
        if (response.status) {
          const chatStorage = JSON.parse(
            sessionStorage.getItem("chatInternal")
          );

          // Used when chat storage doesn't exist
          let updatedChat = [];

          const newMessage = {
            sender: myInfo.user.AgentName,
            message: response.data.message,
            time: response.data.time,
            isBroadcast: true,
          };

          selectedAgentIDs.forEach((id) => {
            const selectedAgent = activeAgents.find(
              (agent) => agent.AgentID === id
            );

            const newChat = {
              id: id,
              agentName: `${selectedAgent.FirstName} ${selectedAgent.LastName}`,
              time: response.data.time,
              messages: [newMessage],
              isViewed: true,
            };

            // Store to updatedChat
            updatedChat.push(newChat);

            // Check if chat storage already existed
            if (chatStorage) {
              // Check if chat already existed
              let index = chatStorage.findIndex((chat) => chat.id === id);

              // If chat already existed, push the new message
              if (index >= 0) {
                chatStorage[index].messages.push(newMessage);
                // Else, create a new chat
              } else {
                chatStorage.push(newChat);
              }

              // Update storage
              sessionStorage.setItem(
                "chatInternal",
                JSON.stringify(chatStorage)
              );
              // If chat storage doesn't exist, create it and fill with updatedChat
            } else {
              sessionStorage.setItem(
                "chatInternal",
                JSON.stringify(updatedChat)
              );
            }
          });

          toast.success("Broadcast message sent");
        } else {
          console.log("Error send broadcast", response.error);
          toast.error("Error send broadcast");
        }
      })
      .catch((err) => {
        console.log("Error send broadcast", err);
        toast.error("Error send broadcast");
      });

    setMessageToBroadcast("");
  };

  return (
    <section className="broadcast">
      <div className="agent-search">
        <div className="search-container">
          <SearchOutlined className="icon" />

          <input
            type="search"
            className="search"
            placeholder="Search agent"
            value={searchValue}
            onChange={(e) => {
              setSearchValue(e.target.value.toLowerCase());
            }}
          />
        </div>
      </div>

      <FormGroup className="toggle-all-container">
        <FormControlLabel
          className="toggle-all"
          control={
            <Switch
              checked={isAllAgentsSelected}
              onChange={() => {
                if (isAllAgentsSelected) {
                  setSelectedAgentIDs([]);
                } else {
                  setSelectedAgentIDs(
                    searchedAgents.map((agent) => agent.AgentID)
                  );
                }
              }}
            />
          }
          label={isAllAgentsSelected ? "Selected all" : "Select all"}
        />
      </FormGroup>

      <AgentList
        activeAgents={searchedAgents}
        isLoading={isAgentListLoading}
        selectedAgentIDs={selectedAgentIDs}
        setSelectedAgentIDs={setSelectedAgentIDs}
      />

      <ChatBox
        placeholder={
          selectedAgentIDs.length === 0
            ? "No recipients selected"
            : "Broadcast message..."
        }
        message={messageToBroadcast}
        setMessage={setMessageToBroadcast}
        handleSendMessage={handleSendBroadcast}
        isBroadcast
        isDisabled={selectedAgentIDs.length === 0}
      />
    </section>
  );
};

export default Broadcast;
